const getMonth = () => {
    const monthList = ['январе','феврале','марте','апреле','мае','июне','июле','августе','сентябре','октябре','ноябре','декабре']
    const date = new Date(); 
    return monthList[date.getMonth()]
}
 
export default getMonth;